import React from "react";
import { Line } from "react-chartjs-2";
import { configureChartFont } from "../../utils/chartFont";

const _Chart = ({ data: chartData }) => {
  configureChartFont();

  const data = {
    labels: chartData.map((l) => l.entry_year || l.year),
    datasets: [
      {
        borderWidth: 2,
        borderColor: '#1F78B4',
        backgroundColor: "transparent",
        data: chartData.map((l) => l.student_count ||  l.class_count ||  l.staff_count ||  l.teacher_count),
      },
    ],
  };

  const options = {
    title: {
      display: false,
      labels: {
        family: "Google Sans",
      },
    },
    plugins: {
      legend: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    borderRadius: 10,
    categoryPercentage: 0.4,
  };

  return <Line data={data} options={options} />;
};

export default _Chart;
